package com.rajen.angrejidictionary.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initPrivacyPolicyPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("PrivacyPolicy.md", FrontMatterElement.Builder { addScalar("title", "Privacy Policy"); }))
}

@Page("/privacy-policy")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun PrivacyPolicyPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("privacy-policy") }) {
        org.jetbrains.compose.web.dom.Text("Privacy Policy")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Last updated: April 2026")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("introduction") }) {
        org.jetbrains.compose.web.dom.Text("Introduction")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We respect your privacy and are committed to protecting your personal data.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("information-we-collect") }) {
        org.jetbrains.compose.web.dom.Text("Information We Collect")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may collect:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Name")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Email address")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Messages submitted via contact form")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("how-we-use-information") }) {
        org.jetbrains.compose.web.dom.Text("How We Use Information")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We use your data to:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Respond to inquiries")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Improve our services")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Maintain website functionality")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("cookies") }) {
        org.jetbrains.compose.web.dom.Text("Cookies")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may use cookies to enhance user experience.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("data-protection") }) {
        org.jetbrains.compose.web.dom.Text("Data Protection")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We implement appropriate security measures to protect your data.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("third-party-services") }) {
        org.jetbrains.compose.web.dom.Text("Third-Party Services")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may use third-party tools that process data on our behalf.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("changes-to-this-policy") }) {
        org.jetbrains.compose.web.dom.Text("Changes to This Policy")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We may update this Privacy Policy from time to time.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("contact-us") }) {
        org.jetbrains.compose.web.dom.Text("Contact Us")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If you have questions, please contact us via the Contact page.")
    }
}
